import React, {useRef} from "react";
import PropTypes from "prop-types";
import HrnbContainer, { HrnbRow } from "./HrnbContainer";
import HrnbInput from "./HrnbInput";
import HrnbSelect from "./HrnbSelect";
import HrnbButton from "./HrnbButton";
import { SearchIcon, ClearIcon } from "../../icons";
import "../../css/components/controls/HrnbSearchFilter.css"; // <- стили ниже

export default function HrnbSearchFilter({
                                             search,
                                             onSearchChange,
                                             onSearchSubmit,
                                             filterValue,
                                             onFilterChange,
                                             filterOptions = [],
                                             placeholder = "Поиск...",
                                             onClear,
                                             debounceMs = 300,
                                             className = "",
                                         }) {
    const timerRef = useRef(null)

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            onSearchSubmit((search || "").trim());
        }
    };

    const handleInputChange = (valOrEvent) => {
        const value =
            typeof valOrEvent === "string"
                ? valOrEvent
                : (valOrEvent && valOrEvent.target && valOrEvent.target.value) || "";
        onSearchChange(value);
    };

    return (
        <HrnbContainer className={className}>
            <HrnbRow className="hrnb-search-filter-row" style={{ gap: 8 }}>
                <form className="hrnb-search-filter-form" onSubmit={(e)=>e.preventDefault()}>
                    <div className="hrnb-search-filter-left">
                        <HrnbInput
                            className="hrnb-search-filter-input"
                            type="search"
                            placeholder={placeholder}
                            value={search}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                            aria-label="Поиск"
                        />
                        <HrnbSelect
                            className="hrnb-search-filter-select"
                            value={filterValue}
                            onChange={onFilterChange || (() => {})}
                            options={[{ value: "", label: "Все типы" }, ...filterOptions]}
                            aria-label="Фильтр"
                        />
                    </div>

                    <div className="hrnb-search-filter-actions">
                        <HrnbButton
                            type="button"
                            icon={<SearchIcon />}
                            variant="primary"
                            onClick = {()=>{
                                if(timerRef.current) {
                                    clearTimeout(timerRef.current)
                                    timerRef.current = null
                                }
                                onSearchSubmit((search || "").trim())
                            }}
                            title="Найти" />
                        <HrnbButton
                            type="button"
                            variant="secondary"
                            icon={<ClearIcon />}
                            title="Сбросить"
                            onClick={()=>{
                                onClear && onClear();
                                if(timerRef.current) {
                                    clearTimeout(timerRef.current)
                                    timerRef.current = null
                                }
                                onSearchSubmit && onSearchSubmit("")
                            }}
                        />
                    </div>
                </form>
            </HrnbRow>
        </HrnbContainer>
    );
}

HrnbSearchFilter.propTypes = {
    search: PropTypes.string,
    onSearchChange: PropTypes.func.isRequired,
    onSearchSubmit: PropTypes.func,
    filterValue: PropTypes.string,
    onFilterChange: PropTypes.func,
    filterOptions: PropTypes.array,
    placeholder: PropTypes.string,
    onClear: PropTypes.func,
    debounceMs: PropTypes.number,
    className: PropTypes.string,
};

HrnbSearchFilter.defaultProps = {
    search: "",
    filterValue: "",
    filterOptions: [],
    placeholder: "Поиск...",
    debounceMs: 300,
    className: "",
};
